import { Navigate, Outlet, useRoutes, useLocation } from "react-router-dom";
import { GuestGuard } from "@app/guard";
import AuthGuard from "@app/guard/AuthGuard";

import { PATH_AUTH, PATH_DASHBOARD } from "./paths";
import * as Configs from "../configs";
import {
  AddProduct,
  AddProduct1,
  EditProduct,
  Product,
} from "@app/modules/product";
import {
  ForgotPasswordPage,
  LoginPage,
  SignUpPage,
  UpdatePasswordPage,
} from "@app/modules/auth";
import { CustomerPage } from "@app/modules/customers";
import { DashboardPage } from "@app/modules/dashboard";
import { SideTopLayout } from "@app/components";
import { SalesPersonDetails, SalesPersonPage } from "@app/modules/salesperson";
import { BrandPage } from "@app/modules/brand";
import { EditProfile } from "@app/modules/my-profile";
import { Requests } from "@app/modules/requests";
import { ModelPage } from "@app/modules/model";
import { ChangeStatusModal } from "@app/modules/requests/view/change-status";
import { CarValuationModal } from "@app/modules/requests/view/add-car-valuation";
import AssignSalesPersonModal from "@app/modules/requests/view/assign-salesperson";
import { RequestDetailPage } from "@app/modules/requests/view/request-detail-page";
import ProducDetail from "@app/modules/product/view/product-detail";
import AssignAgentsModal from "@app/modules/requests/view/assign-agent";

// ----------------------------------------------------------------------

const routeLabels = {
  [PATH_DASHBOARD.product]: "Cars",
  // [PATH_DASHBOARD.addProduct]: "Add Cars",
  [PATH_DASHBOARD.model]: "Model",
  [PATH_DASHBOARD.addModel]: "Add Model",
  [PATH_DASHBOARD.customerPage]: "Customers",
  [PATH_DASHBOARD.dashboard]: "Dashboard",
  [PATH_DASHBOARD.salesPerson]: "User",
  [PATH_DASHBOARD.productDetail]: "Product Detail",
  [PATH_DASHBOARD.brand]: "Brands",
  [PATH_DASHBOARD.editProduct]: "Edit Product",
  [PATH_DASHBOARD.requests]: "Requests",
  [PATH_DASHBOARD.changeStatus]: "Change Status",
  [PATH_DASHBOARD.addProduct1]: "Add Product",
};

function DashboardRoutes() {
  const location = useLocation();

  const activeItem = Object.keys(routeLabels).find((path) =>
    location.pathname.includes(path)
  )
    ? routeLabels[
        Object.keys(routeLabels).find((path) =>
          location.pathname.includes(path)
        )!
      ]
    : "";

  return (
    <AuthGuard>
      <SideTopLayout activeItem={activeItem}>
        <Outlet />
      </SideTopLayout>
    </AuthGuard>
  );
}

export function Router() {
  return useRoutes([
    {
      path: "/",
      element: (
        <AuthGuard>
          <Navigate to={Configs.PATH_AFTER_LOGIN} replace />
        </AuthGuard>
      ),
    },

    {
      element: (
        <GuestGuard>
          <Outlet />
        </GuestGuard>
      ),
      children: [
        {
          path: PATH_AUTH.login,
          element: <LoginPage />,
        },
        // {
        //   path: PATH_AUTH.signUp,
        //   element: <SignUpPage />,
        // },
        // {
        //   path: PATH_AUTH.forgotPassword,
        //   element: <ForgotPasswordPage />,
        // },
        // {
        //   path: PATH_AUTH.updatePassword,
        //   element: <UpdatePasswordPage />,
        // },
      ],
    },

    {
      path: PATH_DASHBOARD.root,
      element: <DashboardRoutes />,
      children: [
        {
          index: true,
          element: <Navigate to={Configs.PATH_AFTER_LOGIN} replace />,
        },
        { path: PATH_DASHBOARD.product, element: <Product /> },
        // { path: PATH_DASHBOARD.addProduct, element: <AddProduct /> },
        { path: PATH_DASHBOARD.model, element: <ModelPage /> },
        // { path: PATH_DASHBOARD.addModel, element: < AddModelPage/> },
        { path: PATH_DASHBOARD.customerPage, element: <CustomerPage /> },
        { path: PATH_DASHBOARD.dashboard, element: <DashboardPage /> },
        { path: PATH_DASHBOARD.salesPerson, element: <SalesPersonPage /> },
        { path: PATH_DASHBOARD.brand, element: <BrandPage /> },
        { path: PATH_DASHBOARD.productDetail, element: <ProducDetail /> },
        { path: PATH_DASHBOARD.editProduct, element: <EditProduct /> },
        {
          path: PATH_DASHBOARD.salesPersonDetails,
          element: <SalesPersonDetails />,
        },
        { path: PATH_DASHBOARD.myProfile, element: <EditProfile /> },
        { path: PATH_DASHBOARD.requests, element: <Requests /> },
        {
          path: `${PATH_DASHBOARD.requests}/:id`,
          element: <RequestDetailPage />,
        },
        { path: PATH_DASHBOARD.changeStatus, element: <ChangeStatusModal /> },
        { path: PATH_DASHBOARD.addValuation, element: <CarValuationModal /> },
        { path: PATH_DASHBOARD.assignAgent, element: <AssignAgentsModal /> },
        {
          path: PATH_DASHBOARD.assignSalesPerson,
          element: <AssignSalesPersonModal />,
        },
        { path: PATH_DASHBOARD.addProduct1, element: <AddProduct1 /> },
      ],
    },
    {
      path:"*",
      element: <Navigate to={Configs.PATH_AFTER_LOGIN} replace />,
    }
  ]);
}
